// This file constains app level constants

export const AppConstants = {
  // following section is for Map related elements
  BreaklineLayerId: 'breakline_layer',
  DrawingsLayerId: 'drawing_layer',
  SurveyPointsLayerId: 'survey_points_layer',
  OriginalTinTrianglesLayerId: 'original_triangles_layer',
  DesignedTinTrianglesLayerId: 'designed_triangles_layer',
  SyncTracingLayerId: 'survey_sync_layer',
  SurfaceLayerId: 'surface_map_service',
  OriginalContourLayerId: 'original_contour_layer',
  DesignedContourLayerId: 'designed_contour_layer',
  SurfaceTinElevationLayerId: 'SurfaceTinElevationLayer',

  transSketchLayerId: 'trans_sketch',
  rotateSketchLayerId: 'rotate_sketch',
  newSurveyLayerId: 'new_survey',

  profileHorizontalGridLineLayerId: 'profile_horizontal_grid',
  profileVerticalGridLineLayerId: 'profile_vertical_grid',
  profileStretchFactor: 10,

  // other sections
  fpacAppGUID: '9c8e774e-73dd-4b3d-a32a-b5fd78baa6ce',

  // surface editing constants
  SURFACE_ORIGINAL: "original",
  SURFACE_USER_EDIT: "user-edit",
  SURFACE_PROGRAMMATIC: "programmatic"
};
